<template>
    <div class="academic-association topic-list">
        <div class="home-header">
            <van-search
                class="header-search"
                @click="$router.push({name:'search'})"
                v-model="value"
                placeholder="搜一搜"
            />
        </div>
        <div v-for="item in tableData" class="topic-list-box" @click="handleTopic(item)">
            <div class="top">
                <img
                    class="logo"
                    :src="item.logo"
                    alt
                />
                <div class="top-name">{{ item.name }}</div>
                <div class="more">
                    更多
                    <img src="/static/img/icon_more.svg" alt />
                </div>
            </div>
            <img
                class="big-img"
                :src="item.cover_img"
                alt
            />
            <div class="box-desc">{{item.desc}}。</div>
        </div>
    </div>
</template>

<script>
import Interface from "@/util/interface"
export default {
    data () {
        return {
            activeTab: 1,
            value: '',
            tableData:[],
        }
    },
    methods: {
        handleTopic (row) {
            this.$router.push({ 'name': 'topic-detail',params:{id:row.id} })
        },
        fetch(scene) {
            if (scene === 'list') {
                let params = {
                    pageSize:999
                };
                Interface.getData('get', Interface.topic.list,params).then((res) => {
                    this.tableData = res.data.list
                })
            }
        },
    },
    created() {
        this.fetch('list')
    },
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/topic/topic-list/index.vue